class customJS {
    constructor() {
        this.setHeaderCartPopup();
        this.isTouchDevice();
        this.checkAndShowSwatchOptions();
    }

    setHeaderCartPopup() {
        var submitButton = null, onlyItemCount = false;
        ProductForm.prototype.addToCartModalPopup(submitButton, onlyItemCount);
    }

    isTouchDevice() {  
        var isTouch = (('ontouchstart' in window) ||  
          (navigator.maxTouchPoints > 0) ||  
          (navigator.msMaxTouchPoints > 0));  
        (isTouch == true) ? document.body.classList.add('is-touchscreen') : '';
    }  
    checkAndShowSwatchOptions() {
        console.log(`checkAndShowSwatchOptions`)
      var allProductsListing = document.querySelectorAll("#swatchOption:not(.swatch-loaded)");
        if (allProductsListing.length > 0) {
            const collectionPath = window.location.pathname;
            allProductsListing.forEach(prd => {
                var prId = prd.getAttribute("data-main-product-id");
                var swatchTag = prd.getAttribute("data-swatch-tags");
                var prHandle = prd.getAttribute("data-main-product-handle");
                fetch(`/collections/all/${swatchTag}?view=swatchesForPlp&cp_handle=${prHandle}`)
                .then(res => res.text())
                .then(data => {
                    document.querySelector(`#swatchOption[data-main-product-id="${prId}"]`).innerHTML = data;
                    document.querySelector(`#swatchOption[data-main-product-id="${prId}"]`).classList.add('swatch-loaded');
                    document.querySelector(`#swatchOption[data-main-product-id="${prId}"] [data-swatch-product-id="${prId}"]`).classList.remove('d-none');

                    var productSwatches = document.querySelectorAll('.product-card-swtach-slider .swiper-wrapper a.swiper-slide img');
                    if (productSwatches.length > 0) {
                        productSwatches.forEach((item) => {
                            item.addEventListener('click', function(e) {
                                var dataId = item.getAttribute('data-img');
                                var dataIdSrc = item.getAttribute('data-img-src');
                                item.closest('.collection-listing-product-grid').querySelectorAll(".swatch-data-mobile .swatch-data-details:not(d-none)").forEach((i) => {i.classList.add('d-none')})
                                item.closest('.collection-listing-product-grid').querySelector(".swatch-data-mobile .swatch-data-details[data-swatch='"+dataId+"']").classList.remove('d-none')
                                var productGrid = item.closest('.collection-listing-product-grid');
                                if(productGrid != null) {
                                    var imgProduct = productGrid.querySelector('.product-card-image img');
                                    imgProduct.setAttribute('srcset', dataIdSrc);
                                    var dataTitle = item.closest('a').getAttribute('title');
                                    var dataHandle = item.closest('a').getAttribute('data-handle');
                                    var dataListPrice = item.closest('a').getAttribute('data-listPrice');
                                    var dataPrice = item.closest('a').getAttribute('data-price');
                                    productGrid.querySelector('.card-img a').setAttribute('href',collectionPath +'/products/'+ dataHandle);
                                    productGrid.querySelector('span.price span').innerHTML = dataPrice;
                                    if (!!productGrid.querySelector('s.price')) {
                                        if (dataListPrice === dataPrice) {
                                            productGrid.querySelector('s.price').classList.remove('d-block');
                                            productGrid.querySelector('s.price').classList.add('d-none');
                                        }
                                        else if (dataListPrice != dataPrice) {
                                            productGrid.querySelector('s.price').classList.add('d-block');
                                            productGrid.querySelector('s.price').classList.remove('d-none');
                                        }
                                    }
                                    productGrid.querySelector('h6 a.product-link').innerHTML = dataTitle;
                                    productGrid.querySelector('h6 a.product-link').setAttribute('href',collectionPath +'/products/'+ dataHandle);
                                }
                            })
                        })
                    }
                  if (typeof window.setupAddToCartFunction === 'function') { window.setupAddToCartFunction(); }
                  if (typeof window.setupAddToCartFunctionDesk === 'function') { window.setupAddToCartFunctionDesk(); }
                  if (typeof window.setupContinueShoppingButton === 'function') { window.setupContinueShoppingButton(); }
                //   window.setupAddToCartFunction();
                //    window.setupAddToCartFunctionDesk();
                //   window.setupContinueShoppingButton();
                })
            })
        }
    }
}

new customJS;








